export const enums = {
  roles: [
    {
      label: 'admin',
      value: 'admin',
    },
    {
      label: 'editor',
      value: 'editor',
    },
  ],
};
